import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="current-item"
export default class extends Controller {
  static targets = ["link"];
  connect() {
    if (window.location.pathname === this.element.dataset.url) {
      this.linkTarget.classList.add("active");
    } else {
      this.linkTarget.classList.remove("active");
    }
  }
}
